class CustomControl {
  map;
  container;

  constructor(map, container?) {
    this.map = map;
    // this.container = container;
  }

  onAdd(map): void {
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'pin-custom-control';
    const button = this.createButton();
    this.container.appendChild(button);

    return this.container;
  }

  onRemove(): void {
    const mapContainer: HTMLDivElement = this.map.getContainer();
    const eCollection = document.getElementsByClassName('pin-custom-control');

    for (const node of Array.from(eCollection)) {
      node.parentNode.removeChild(node);
    }
  }

  createButton(): HTMLElement {
    const el = document.createElement('button');
    el.textContent = 'Pin';
    el.addEventListener(
      'click',
      (e: Event) => {
        this.onClick();
        e.stopPropagation();
      },
      false
    );

    return el;
  }

  onClick(): void {
    const mapContainer: HTMLDivElement = this.map.getContainer();
    const button: HTMLButtonElement = mapContainer.querySelector(
      '.pin-custom-control > button'
    );
    if (button.textContent === 'Pin') {
      this.pinMap(button);
    } else {
      this.unpinMap(button);
    }
  }

  pinMap(button: HTMLButtonElement): void {
    button.textContent = 'Unpin';
    this.map.canSync = false;
  }

  unpinMap(button): void {
    button.textContent = 'Pin';
    this.map.canSync = true;
  }
}

export class MapBoxSync {
  // Map
  maps: any;

  fnsMove = [];
  fnsHover = [];

  constructor(...args) {
    const argLength = args.length;

    if (argLength === 1) {
      this.maps = [args[0]];
    } else {
      this.maps = args.map((x) => x);
    }

    this.maps = this.maps.map((map, index) => {
      this.fnsMove[index] = this.sync.bind(
        this,
        map,
        this.maps.filter((_, i) => {
          return i !== index;
        })
      );

      this.fnsHover[index] = this.onHover.bind(this, map);

      map.canSync = true;
      return map;
    });

    this.on();
    this.onHover();
  }

  on(): void {
    this.maps.forEach((map, index) => {
      map.on('move', this.fnsMove[index]);
    });
  }

  off(): void {
    this.maps.forEach((map, index) => {
      map.off('move', this.fnsMove[index]);
    });
  }

  private onHover(): void {
    this.maps.forEach((map) => {
      const customControl = new CustomControl(map);

      map.on('load', () => map.addControl(customControl));
    });
  }

  sync(master, clones): void {
    this.off();
    this.moveToMapPosition(master, clones);
    this.on();
  }

  moveToMapPosition(master, clones): void {
    const center = master.getCenter();
    const zoom = master.getZoom();
    const bearing = master.getBearing();
    const pitch = master.getPitch();

    clones.forEach((clone) => {
      if (clone.canSync) {
        clone.jumpTo({
          center,
          zoom,
          bearing,
          pitch,
        });
      }
    });
  }
}
